import { render, staticRenderFns } from "./SidebarProfile.vue?vue&type=template&id=9d18f152&"
import script from "./SidebarProfile.vue?vue&type=script&lang=js&"
export * from "./SidebarProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SidebarProfile.vue"
export default component.exports